import { forwardRef, useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomListItem } from 'src/components/CustomListItem';
import { CustomListItemIcon } from 'src/components/CustomListItemIcon';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GENERATION_IMPROVE_MODE, getGenerationImproveModeLabel } from 'src/data/generation';

import { ImproveModeIcon } from '../ImproveModeIcon';

import { useStyles } from './useStyles';

export const InternalListItem = forwardRef(
  ({ className, mode, onClick, disabled, endIcon }, ref) => {
    const styles = useStyles();

    const handleClick = useCallback(() => {
      onClick(mode);
    }, [onClick, mode]);

    return (
      <CustomListItem
        className={cx(styles.root, className)}
        ref={ref}
        onClick={handleClick}
        disabled={disabled}
        data-testid="GenerationImproveList_Item"
        button
      >
        <CustomListItemIcon className={styles.listItemIcon}>
          <ImproveModeIcon
            className={styles.icon}
            mode={mode}
          />
        </CustomListItemIcon>

        <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
          {getGenerationImproveModeLabel(mode)}
        </CustomTypography>

        {endIcon}
      </CustomListItem>
    );
  }
);

InternalListItem.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.oneOf(Object.values(GENERATION_IMPROVE_MODE)).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  endIcon: PropTypes.node,
};
InternalListItem.defaultProps = {
  className: '',
  disabled: false,
  endIcon: null,
};
